import { useState } from "react";
import Toggle from "src/components/Toggle";
import { cn } from "src/lib/cn";
import { Text } from "src/sudokit/components/Text";
import { MultiOptionSelect, useSelectItem } from "/src/sudokit/components/SudoSelect/MultiOptionSelect";

const ABBREVIATIONS = {
  "whole-book": "All chapters",
  "specific-chapters": "Customize POV & tense per chapter",
};

const APPLY_TO_OPTIONS = [
  {
    value: "whole-book",
    label: "Same for all chapters",
    subLabel: "Keeps your narrative consistent across the book",
  },
  {
    value: "specific-chapters",
    label: "Customize per chapter",
    subLabel: "More flexible, great for complex stories",
  },
];

const ApplyToRadioButtons = ({ value, onChange }) => {
  useSelectItem(value, true);

  return (
    <div>
      <div className="px-2 pb-2">
        {APPLY_TO_OPTIONS.map((option) => (
          <div
            key={option.value}
            className={cn(
              "flex items-center gap-2 pb-3 pt-2 px-2.5 mt-2 mb-2 last:mb-0 text-white bg-app-document-background !border !border-solid duration-150 ease-in-out cursor-pointer rounded-lg",
              value === option.value
                ? "!border-app-primary-cta-high-contrast text-app-primary-cta-high-contrast cursor-default hover:cursor-default"
                : "!border-app-grey-2 text-app-grey-0 hover:text-app-grey-0 hover:!border-app-grey-1 hover:bg-app-grey-4 active:scale-[0.995] hover:scale-[1.005] cursor-pointer"
            )}
            onClick={() => {
              onChange(option.value);
            }}
          >
            {/* Set the value on the parent so the whole box is clickable */}
            <Toggle checked={value === option.value} />
            <div className="w-[90%] font-inter">
              <Text
                size="base"
                weight="medium"
                color={value === option.value ? "primary-cta" : "grey-0"}
                font="inter"
              >
                {option.label}
              </Text>
              <span className={`text-left font-inter ${value === option.value ? "text-app-primary-cta-high-contrast" : "text-[var(--grey-2)]"}`}>
                <Text
                  lineHeight="snug"
                  weight="medium"
                  color={value === option.value ? "primary-cta" : "grey-2"}
                  font="inter"
                  size="sm"
                >
                  {option.subLabel}
                </Text>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function ApplyToSelectorButton ({ value, onChange, showLabel = false, summaryFn, className = "!w-[380px]", collisionBoundarySelector = ".project-main", inClassName = "", ...props }) {
  const [isOpen, setIsOpen] = useState(false);
  const handleApplyToChange = (selectedOption) => {
    onChange(selectedOption);
    setIsOpen(false);
  };

  const onOpenChange = (open) => {
    setIsOpen(open);
  };

  const defaultSummaryFn = (selectedValues) => {
    const currentValue = selectedValues[0]; // Should only be one selected value
    const selectedOption = APPLY_TO_OPTIONS.find((option) => option.value === currentValue);
    return ABBREVIATIONS[selectedOption?.value] || "Select scope";
  };

  const actualSummaryFn = summaryFn || defaultSummaryFn;

  return (
    <div className="flex items-center gap-2">
      {showLabel && <p className="font-inter font-medium text-app-grey-0">Apply to:</p>}
      <MultiOptionSelect
        placeholder="Select scope"
        variant="tertiary"
        summaryFn={actualSummaryFn}
        className={className}
        collisionBoundarySelector={collisionBoundarySelector}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        {...props}
      >
        <ApplyToRadioButtons
          value={value}
          onChange={handleApplyToChange}
        />
      </MultiOptionSelect>

    </div>
  );
}

export default ApplyToSelectorButton;
